//@flow

import env from '../../../../environment';
import {getCreator} from '../../../../http';

export const endpoints = Object.freeze({
  GET_DELIVERY_METHODS: `${env.baseApiUrl}/im/admin/delivery`,
});

export const getDeliveryMethodsApi = getCreator(endpoints.GET_DELIVERY_METHODS);
